'use client';

import { Divider, Justifiable, Link, Text, TextLevels, TypographyBold, View } from '@bytel/trilogy-react';

import { MobilePlanType } from '@app-types/plan';

import { InlinePrice } from '@components/inline-price';

import { PricesDetails } from '@product-detail/helpers';
import { ClickEvent } from '@trilogy-ds/react/lib/events/OnClickEvent';

type TicketPlanProps = {
    plan: MobilePlanType;
    openPlanModal: ClickEvent;
    prices: PricesDetails;
};

export function TicketPlan({ plan, openPlanModal, prices }: TicketPlanProps) {
    const { planPrices } = prices;

    return (
        <>
            <Divider />
            <View flexable justify={Justifiable.SPACE_BETWEEN}>
                <div>
                    <Text
                        typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}
                        marginless={!!planPrices.promoDuration}
                        level={TextLevels.TWO}
                    >
                        {plan.name.includes('Forfait') ? plan.name : `Forfait ${plan.name}`}
                    </Text>
                    {Boolean(planPrices.promoDuration && planPrices.promoDuration > 0) && (
                        <Text level={TextLevels.THREE} marginless>
                            {`Pendant ${planPrices.promoDuration} mois puis`}&nbsp;
                            <InlinePrice amount={planPrices.forever} period='mois' level={TextLevels.THREE} typo={[]} />
                        </Text>
                    )}
                    <Text level={TextLevels.THREE} className='capitalize-first'>
                        {plan.obligationLabel}
                    </Text>
                    <Text level={TextLevels.TWO}>
                        <Link onClick={openPlanModal} role='button'>
                            Voir le détail du forfait
                        </Link>
                    </Text>
                </div>
                {planPrices.mainAmount >= 0 && (
                    <InlinePrice level={TextLevels.TWO} amount={planPrices.mainAmount} period='mois' />
                )}
            </View>
        </>
    );
}
